/* eslint-disable react-hooks/exhaustive-deps */
import React, { memo } from "react";
import useStyles from "../../../../styles";
import BannerLoyalty from "components/BannerLoyalty";
import MenuInfo from "../MenuInfo";
import Information from "../Information";
import ConfirmRewardCRM from "../ComfirmRewardCRM";
import LoyaltyCRM from "../LoyaltyCRM";
import HeaderHomePage from "../HeaderHomePage";
import HomeProductListLoadMore from "../HomeProductListLoadMore";

import { infoOpacity } from "utils/utils";
import { Grid } from "@material-ui/core";
import { useHistory } from "react-router-dom";

const MainHomePage = props => {
	const classes = useStyles();
	const {
		refProductListScroll,
		isPull,
		totalNotification,
		infoShop,
		dataInfoLoyalty,
		listLoyalty,
		products,
		totalListProduct,
		carts,
		business,
		height,
		heightScroll,
		handleScroll,
		setHeightProductsScroll,
		handleSearchProduct,
		handleInfoLoyaltyDefault,
		handleClickProgram,
		setConfirmReward,
		updateChangeListProduct,
		dispatchAlertMessage,
		dispatchGetListProduct,
		handleOnTouchStartPull
	} = props;

	const history = useHistory();
	const isCurrentSale = infoShop?.isCurrentSale || false;

	return (
		<Grid
			style={{
				height: height,
				overflow: "hidden"
			}}
			onScroll={handleScroll}
		>
			<Grid onTouchStart={handleOnTouchStartPull}>
				<HeaderHomePage
					mainClasses={{ root: classes.rootHeaderInput }}
					style={{
						zIndex: 666,
						opacity: infoOpacity(heightScroll, 80),
						display: !infoOpacity(heightScroll, 60) === 1 && "none"
					}}
					subClasses={{ root: classes.headerInput }}
					total={totalNotification}
					handleSearchProduct={() => {
						history.push("/find_product");
					}}
				/>
				<HeaderHomePage
					mainClasses={{ root: classes.rootHeader }}
					style={{
						opacity: 1 - infoOpacity(heightScroll, 160)
					}}
					total={totalNotification}
					handleSearchProduct={handleSearchProduct}
				/>
				<Grid style={{ opacity: 1 - infoOpacity(heightScroll, 100) }}>
					<Information
						data={infoShop}
						alertMessage={dispatchAlertMessage}
						dataInfoLoyalty={dataInfoLoyalty}
					/>
				</Grid>
				{isCurrentSale && (
					<Grid style={{ padding: "16px 16px 0px 16px" }}>
						<BannerLoyalty
							handleInfoLoyaltyDefault={handleInfoLoyaltyDefault}
							dataInfoLoyalty={dataInfoLoyalty}
							properties={dataInfoLoyalty[infoShop?.crmNextLevel]}
							currentSales={infoShop?.currentSales}
							achivedSales={infoShop?.achievedSales}
							nextLevel={infoShop?.crmNextLevel}
							currentLevel={infoShop?.crmLevel}
							isInfo={true}
							levelAchieved={
								infoShop?.levelAchieved === "true"
									? true
									: false
							}
						/>
					</Grid>
				)}
				<MenuInfo data={infoShop} />
				<LoyaltyCRM
					isLoyalty={infoShop?.isLoyalty || false}
					handleClickProgram={handleClickProgram}
					listLoyalty={listLoyalty}
				/>
				<ConfirmRewardCRM
					isSignRewardConfirm={infoShop?.isSignRewardConfirm || false}
					setConfirmReward={setConfirmReward}
				/>
			</Grid>
			<HomeProductListLoadMore
				refProductListScroll={refProductListScroll}
				infoShop={infoShop}
				products={products}
				carts={carts}
				isPull={isPull}
				setHeightProductsScroll={setHeightProductsScroll}
				business={business}
				totalListProduct={totalListProduct}
				getListProduct={dispatchGetListProduct}
				updateChangeListProduct={updateChangeListProduct}
			/>
		</Grid>
	);
};

export default memo(MainHomePage);
